import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { UserContainer, Section, Heading } from '../user/User.styles'
import UserBookingsCard from '../user/components/userBookingsCard/UserBookingsCard'
import AdminNotes from '../user/components/adminNotes/AdminNotes'
import { firestore } from '../../../../utils/firebase/firebase'
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material'
import ManageFamily from '../user/components/ManageFamily'
import Classes from '../user/components/Classes'
import AdminPage from '../../../../components/page/AdminPage'
import GuestPass from '../components/GuestPass'
import useUser from '../../../account/useUser'
import PersonalDetails from '../user/components/PersonalDetails'
import Loader from '../../../../components/Loader'
import { toast } from 'react-toastify'
import TabPanel from '../../../../components/TabPanel'
import Memberships from '../components/Memberships'
import UserPayments from '../user/components/Payments'

function UserPage() {
  const params = useParams()
  const [subscriptions, setSubscriptions] = useState([])
  const [bookings, setBookings] = useState([])
  const [tabs, setTabs] = useState(0)
  const { user, loading, error } = useUser(params.uid)

  const handleTabChange = (_, newValue) => {
    setTabs(newValue)
  }

  const getUserBookings = async () => {
    firestore
      .collection('bookings')
      .where('user.id', '==', params.uid)
      .orderBy('startTime')
      .onSnapshot((querySnapshot) => {
        var bookings = []
        querySnapshot.forEach((doc) => {
          bookings.push({ data: doc.data(), id: doc.id })
        })
        setBookings(bookings)
      })
  }

  useEffect(() => {
    const getSubscriptions = async () => {
      console.log('getting subscription...')
      const subscriptions = []
      firestore
        .collection(`users/${params.uid}/subscriptions`)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            subscriptions.push({ data: doc.data(), id: doc.id })
          })
          setSubscriptions(subscriptions)
          console.log('sub: ', subscriptions)
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
    }
    getSubscriptions()
    getUserBookings()
    //eslint-disable-next-line
  }, [params.uid])

  if (loading) {
    return <Loader />
  }

  if (error) {
    toast.error('Error loading user')
    return
  }

  return (
    <AdminPage>
      <Box>
        <Tabs value={tabs} onChange={handleTabChange}>
          <Tab label='Personal Details' />
          <Tab label='Admin Notes' />
          <Tab label='Membership details' />
          {/* <Tab label='Payments' /> */}
          {/* <Tab label='Bookings' />
          <Tab label='Classes' /> */}
          <Tab label='Guest Pass' />
          {user.memberType === 'family' && <Tab label='Family' />}
        </Tabs>
        <Divider />
        <UserContainer>
          <TabPanel value={tabs} index={0}>
            <PersonalDetails user={user} />
          </TabPanel>
          <TabPanel value={tabs} index={1} sx={{ width: '100%' }}>
            <AdminNotes user={user} />
          </TabPanel>
          <TabPanel value={tabs} index={2} sx={{ width: '100%' }}>
            <Section>
              <Memberships subscriptions={subscriptions} />
            </Section>
          </TabPanel>
          <TabPanel value={tabs} index={999} sx={{ width: '100%' }}>
            <UserPayments user={user} />
          </TabPanel>
          <TabPanel value={tabs} index={4}>
            <Section>
              <Heading>
                <Typography variant='h5'>Bookings</Typography>
              </Heading>
              <UserBookingsCard
                getUserBookings={getUserBookings}
                bookings={bookings}
                bookingType='future'
              />
              <UserBookingsCard
                getUserBookings={getUserBookings}
                bookingType='past'
                bookings={bookings}
              />
              <UserBookingsCard
                getUserBookings={getUserBookings}
                bookingType='recurring'
                bookings={bookings}
              />
            </Section>
          </TabPanel>
          <TabPanel value={tabs} index={5}>
            <Classes user={user} />
          </TabPanel>
          <TabPanel value={tabs} index={3}>
            {user && <GuestPass user={user} />}
          </TabPanel>
          <TabPanel value={tabs} index={7}>
            <ManageFamily family={user.family} />
          </TabPanel>
        </UserContainer>
      </Box>
    </AdminPage>
  )
}

export default UserPage
